module.exports = __webpack_public_path__ + "img/works_starfield_e_btm_m.53d2c0c6.jpg";